exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SearchBox{border-bottom:2px solid #c7c6c7;margin:0 35px 26px;padding:26px 0 26px 55px;position:relative;display:none}.SearchBox span{width:31px;height:31px;position:absolute;top:23px;left:0;-webkit-mask:url(\"/static/icons/busca.svg\") no-repeat 0 0;mask:url(\"/static/icons/busca.svg\") no-repeat 0 0;-webkit-mask-size:100%;mask-size:100%;background-color:#fff;transition:all .2s linear;cursor:pointer}.SearchBox input{border:none;background-color:transparent;font:inherit;font-size:2em;color:#fff}.SearchBox input::placeholder{color:#eee}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-458deba9","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Search.vue
// module id = 198
// module chunks = 0